/* eslint-disable  */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { bindActionCreators } from "redux";
import { productActionCreators } from "../../services/Actions";
import { GetUserProfile } from "../../services/Actions/authActions";
import RenderHirePurchasePage from "../RenderHirePurchasePage";
import * as moment from "moment";
import Loader from "../../Components/Loader";
import { ToastContainer, toast } from "react-toastify";
import { debounce } from "lodash";
import ReactPaginate from "react-paginate";
import {
  FiSearch,
  FiCheckCircle,
  FiCalendar,
  FiMapPin,
  FiEye,
} from "react-icons/fi";

function ApprovedOrders() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { GetApprovedOrders, ResetProductResponse } = bindActionCreators(
    productActionCreators,
    dispatch
  );

  const product = useSelector((state) => state.product);
  const { isLoading, orders, response, paginate } = product;

  const [limit, setLimit] = useState(15);
  const [pageCount, setPageCount] = useState(0);

  useEffect(() => {
    setPageCount(Number(paginate?.total) || 0);
  }, [paginate]);

  useEffect(() => {
    dispatch(GetUserProfile());
    GetApprovedOrders(true, 1, limit, null);
  }, []);

  useEffect(() => {
    GetApprovedOrders(true, 1, limit, null);
  }, [limit]);

  const handlePageClick = (event) => {
    GetApprovedOrders(true, event.selected + 1, limit, null);
  };

  const onSearchTextChange = debounce((e) => {
    const val = e?.target?.value;
    GetApprovedOrders(true, 1, limit, val ? `&search=${val}` : null);
  }, 800);

  useEffect(() => {
    if (response?.state === "SUCCESS") {
      toast.success(response?.message);
      setTimeout(() => ResetProductResponse(), 1500);
    } else if (response?.state === "ERROR") {
      toast.error(response?.message);
      setTimeout(() => ResetProductResponse(), 1500);
    }
  }, [response?.state]);

  return (
    <div className="min-h-screen bg-gray-50/30">
      <RenderHirePurchasePage>
        {isLoading && <Loader />}

        {/* --- Page Header --- */}
        <div className="mb-6 flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div>
            <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-2">
              <FiCheckCircle className="text-green-500" /> Approved Orders
            </h2>
            <p className="text-sm text-gray-500 mt-1">
              Manage and view all verified hire purchase requests
            </p>
          </div>
        </div>

        {/* --- Filters Area --- */}
        <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 mb-6 flex flex-col md:flex-row gap-4">
          <div className="relative flex-grow">
            <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
            <input
              type="search"
              placeholder="Search by staff ID or customer name..."
              className="w-full pl-10 pr-4 py-2.5 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-green-500 outline-none transition-all text-sm"
              onChange={onSearchTextChange}
            />
          </div>

          <div className="flex items-center gap-3 bg-gray-50 px-3 py-1 rounded-lg border border-gray-200">
            <label className="text-xs font-bold text-gray-500 uppercase tracking-wider">
              Show:
            </label>
            <select
              className="bg-transparent text-sm font-semibold text-gray-700 outline-none cursor-pointer"
              onChange={(e) => setLimit(e.target.value)}
              value={limit}
            >
              {[15, 25, 50, 100].map((num) => (
                <option key={num} value={num}>
                  {num} Rows
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* --- Table Section --- */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-left">
              <thead>
                <tr className="bg-gray-50 border-b border-gray-100">
                  <th className="px-6 py-4 text-xs font-bold uppercase text-gray-500">
                    Member Details
                  </th>
                  <th className="px-6 py-4 text-xs font-bold uppercase text-gray-500">
                    Affordability
                  </th>
                  <th className="px-6 py-4 text-xs font-bold uppercase text-gray-500">
                    Date Approved
                  </th>
                  <th className="px-6 py-4 text-xs font-bold uppercase text-gray-500">
                    Facility
                  </th>
                  <th className="px-6 py-4 text-right">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50">
                {orders?.length > 0 ? (
                  orders.map((order, index) => (
                    <tr
                      key={index}
                      className="hover:bg-green-50/30 transition-colors group"
                    >
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-3">
                          <div className="relative">
                            <img
                              className="w-10 h-10 rounded-full object-cover ring-2 ring-white shadow-sm"
                              src={
                                order?.user_id?.profile_image ||
                                "/images/dev/avarta2.jpeg"
                              }
                              alt="profile"
                            />
                            <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-green-500 border-2 border-white rounded-full"></div>
                          </div>
                          <div>
                            <p className="text-sm font-bold text-gray-900">
                              {order?.user_id?.name}
                            </p>
                            <p className="text-xs font-mono text-blue-600 px-1 rounded inline-block">
                              {order?.user_id?.staff_id}
                            </p>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-50 text-blue-700 border border-blue-200">
                          {order?.affordability}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-2 text-sm text-gray-600">
                          <FiCalendar className="text-gray-400" />
                          {moment(order?.created_at).format("MMM Do, YYYY")}
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-2 text-sm text-gray-600 uppercase tracking-tight">
                          <FiMapPin className="text-gray-400" />
                          {order?.facility}
                        </div>
                      </td>
                      <td className="px-6 py-4 text-right">
                        <button
                          onClick={() =>
                            history.push({
                              pathname: "/mart/order-detailed",
                              state: order,
                            })
                          }
                          className="p-2 text-gray-400 hover:text-green-600 hover:bg-green-100 rounded-full transition-all"
                          title="View Details"
                        >
                          <FiEye size={18} />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="5"
                      className="px-6 py-20 text-center text-gray-400"
                    >
                      <div className="flex flex-col items-center">
                        <p className="text-lg font-medium">
                          No approved orders yet
                        </p>
                        <p className="text-sm">
                          Once orders are approved, they will appear here.
                        </p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* --- Pagination --- */}
          {orders?.length > 0 && (
            <div className="p-6 border-t border-gray-100 flex justify-center bg-gray-50 dark:bg-gray-700">
              <ReactPaginate
                breakLabel="..."
                nextLabel="Next"
                previousLabel="Prev"
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                pageCount={Math.ceil(pageCount / limit)}
                containerClassName="flex items-center gap-2"
                pageLinkClassName="px-4 py-2 rounded-lg bg-white border border-gray-200 text-sm font-medium hover:border-green-500 hover:text-green-600 transition-all"
                activeLinkClassName="!bg-green-600 !text-white !border-green-600 shadow-md shadow-green-200"
                previousLinkClassName="px-4 py-2 rounded-lg bg-white border border-gray-200 text-sm font-medium hover:bg-gray-50"
                nextLinkClassName="px-4 py-2 rounded-lg bg-white border border-gray-200 text-sm font-medium hover:bg-gray-50"
                disabledLinkClassName="opacity-40 cursor-not-allowed"
              />
            </div>
          )}
        </div>
        <ToastContainer autoClose={3000} position="bottom-right" />
      </RenderHirePurchasePage>
    </div>
  );
}

export default ApprovedOrders;
